<div class="bg-white rounded mb-3">
    <div class="border-bottom border-2">
      <div class="px-4">
        <h3 class="pt-2">Manual Payment</h3>
      </div>
    </div>
    <div class="p-4">
        <div class="container">
          <div class="form-group row">
            <div class="col-12">
                <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
                    <div  class="mb-3">
                      <label for="business">Select Business <span class="text-danger">*</span></label>
                      <app-select-box-search  (valueChange)="displayPaymentMethod($event)" [placeholder]="'select business ..'" [list]="businesses"
                      [searchKey]="'name'" >
  </app-select-box-search>
                      <div *ngIf="paymentForm.get('business').touched && paymentForm.get('business').invalid">
                        <small class="error text-danger">Business is required.</small>
                      </div>
                    </div>

                  
                    <div>
                      <label for="paymentOption">Select Payment Option  <span class="text-danger">*</span></label>
                      <select formControlName="paymentOption" id="paymentOption"  class="form-control mb-3 form-select">
                        <option *ngFor="let option of paymentOptions" [value]="option.id">{{ option.name }}</option>
                      </select>
                      <div *ngIf="paymentForm.get('paymentOption').touched && paymentForm.get('paymentOption').invalid">
                        <small class="error text-danger">Payment option is required.</small>
                      </div>
                    </div>
                  
                    <div>
                      <label for="amount">Amount  <span class="text-danger">*</span></label>
                      <input type="number" formControlName="amount" id="amount"  class="form-control mb-3">
                      <div *ngIf="paymentForm.get('amount').touched && paymentForm.get('amount').invalid">
                        <small class="error text-danger" *ngIf="paymentForm.get('amount').errors?.required">Amount is required.</small>
                        <small class="error text-danger" *ngIf="paymentForm.get('amount').errors?.min">Amount must be greater than 0.</small>
                      </div>
                    </div>
                  
                    <div>
                      <label for="buyerName">Buyer Name  <span class="text-danger">*</span></label>
                      <input type="text" formControlName="buyerName" id="buyerName"  class="form-control mb-3">
                      <div *ngIf="paymentForm.get('buyerName').touched && paymentForm.get('buyerName').invalid">
                        <small class="error text-danger">Buyer name is required.</small>
                      </div>
                    </div>
                  
                    <div>
                      <label for="buyerEmail">Buyer Email  <span class="text-danger">*</span></label>
                      <input type="email" formControlName="buyerEmail" id="buyerEmail"  class="form-control mb-3">
                      <div *ngIf="paymentForm.get('buyerEmail').touched && paymentForm.get('buyerEmail').invalid">
                        <small class="error text-danger" *ngIf="paymentForm.get('buyerEmail').errors?.required">Buyer email is required.</small>
                        <small class="error text-danger" *ngIf="paymentForm.get('buyerEmail').errors?.email">Invalid email format.</small>
                      </div>
                    </div>
                  
                    <div>
                      <label for="buyerMobile">Buyer Mobile  <span class="text-danger">*</span></label>
                      <input type="tel" formControlName="buyerMobile" id="buyerMobile"  class="form-control mb-3">
                      <div *ngIf="paymentForm.get('buyerMobile').touched && paymentForm.get('buyerMobile').invalid">
                        <small class="error text-danger">Buyer mobile is required.</small>
                      </div>
                    </div>
                  
                    <div>
                      <label for="description">Description</label>
                      <textarea formControlName="description" id="description"  class="form-control mb-3"></textarea>
                    </div>
                  
                    <div>
                      <label for="providerReference">Provider Reference Number</label>
                      <input type="text" formControlName="providerReference" id="providerReference"  class="form-control mb-3">
                    </div>
                    <div class="row justify-content-end">
                        <div class="col-auto">
                          <button class="btn btn-primary mr-2" type="submit" [disabled]="!paymentForm.valid">Submit</button>
                        </div>
                      </div>
                  </form>
            </div>
        </div>
      </div>
    </div>
    </div>


  